/**
 * Coordinate conversion utilities for handling GeoJSON [lon, lat] <-> Leaflet [lat, lon] format
 */

/**
 * Validate and convert coordinates from GeoJSON format [lon, lat] to Leaflet format [lat, lon]
 */
export const convertGeoJsonToLeaflet = (
  coords: any[] | [number, number][] | undefined,
): [number, number][] => {
  if (!Array.isArray(coords)) return [];
  return coords
    .filter(
      (coord): coord is [number, number] =>
        Array.isArray(coord) &&
        coord.length === 2 &&
        typeof coord[0] === "number" &&
        typeof coord[1] === "number",
    )
    .map(([lon, lat]) => [lat, lon]);
};

/**
 * Validate and convert coordinates from Leaflet format [lat, lon] to GeoJSON format [lon, lat]
 */
export const convertLeafletToGeoJson = (
  coords: any[] | [number, number][] | undefined,
): [number, number][] => {
  if (!Array.isArray(coords)) return [];
  return coords
    .filter(
      (coord): coord is [number, number] =>
        Array.isArray(coord) &&
        coord.length === 2 &&
        typeof coord[0] === "number" &&
        typeof coord[1] === "number",
    )
    .map(([lat, lon]) => [lon, lat]);
};
